const Countries = [
    {id: 105, name: "Republic of Ireland"},
    {id: 229, name: "Northern Ireland"}
]

export default Countries;